import React, { useEffect, useState } from "react";
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";
import { injectKpiStyles } from "../DataManagment/Quantative/component/kpiStyles";
import IntensityNumeratorConfig from "./Components/IntensityNumeratorConfig";
import IntensityDenominatorConfig from "./Components/IntensityDenominatorConfig";

const API = config.POSTLOGIN_API_URL_COMPANY;

injectKpiStyles();

const cardStyle = {
  background: "var(--surface)",
  border: "1px solid var(--rule)",
  borderRadius: 12,
  padding: "20px 24px",
  marginBottom: 16,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
};

const IntensitySettings = () => {
  const [cascade, setCascade] = useState({});
  const [configs, setConfigs] = useState([]);
  const [denominators, setDenominators] = useState([]);

  useEffect(() => {
    fetchCascade();
    fetchConfigs();
    fetchDenominators();
  }, []);

  const fetchCascade = async () => {
    const { isSuccess, data } = await apiCall(`${API}intensity/kpis`, {}, {}, "GET");
    if (isSuccess) setCascade(data?.data?.cascade || {});
  };

  const fetchConfigs = async () => {
    const { isSuccess, data } = await apiCall(`${API}intensity/config`, {}, {}, "GET");
    if (isSuccess) setConfigs(data?.data || []);
  };

  const fetchDenominators = async () => {
    const { isSuccess, data } = await apiCall(`${API}intensity/denominator-config`, {}, {}, "GET");
    if (isSuccess) setDenominators(data?.data || []);
  };

  return (
    <div style={{ padding: "4px 0" }}>
      <h5 style={{ fontWeight: 700, marginBottom: 16, color: "var(--ink)", fontSize: 16 }}>Intensity Settings</h5>

      <div style={cardStyle}>
        <IntensityNumeratorConfig
          configs={configs}
          cascade={cascade}
          onRefresh={fetchConfigs}
        />
      </div>

      <div style={cardStyle}>
        <IntensityDenominatorConfig
          denominators={denominators}
          onRefresh={fetchDenominators}
        />
      </div>
    </div>
  );
};

export default IntensitySettings;
